/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 7H12M6 11H12M6 15H8M19 6L19 18M22 8V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="14"
				height="20"
				rx="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="14"
				height="20"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M6 7H12M6 11H12M6 15H8M19 6L19 18M22 8V16M8.4 22H9.6C11.8402 22 12.9603 22 13.816 21.564C14.5686 21.1805 15.1805 20.5686 15.564 19.816C16 18.9603 16 17.8402 16 15.6V8.4C16 6.15979 16 5.03968 15.564 4.18404C15.1805 3.43139 14.5686 2.81947 13.816 2.43597C12.9603 2 11.8402 2 9.6 2H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.367 1.25H8.4H9.6H9.633C10.7251 1.24999 11.5906 1.24999 12.2883 1.30699C13.0017 1.36527 13.6053 1.48688 14.1565 1.76772C15.0502 2.22312 15.7769 2.94978 16.2323 3.84354C16.5131 4.39472 16.6347 4.99834 16.693 5.71173C16.75 6.40935 16.75 7.27483 16.75 8.36695V8.36697V8.36698V8.4V15.6V15.633V15.633V15.633C16.75 16.7252 16.75 17.5907 16.693 18.2883C16.6347 19.0017 16.5131 19.6053 16.2323 20.1565C15.7769 21.0502 15.0502 21.7769 14.1565 22.2323C13.6053 22.5131 13.0017 22.6347 12.2883 22.693C11.5906 22.75 10.7252 22.75 9.63302 22.75H9.6H8.4H8.36698C7.27485 22.75 6.40935 22.75 5.71173 22.693C4.99834 22.6347 4.39472 22.5131 3.84354 22.2323C2.94978 21.7769 2.22312 21.0502 1.76772 20.1565C1.48688 19.6053 1.36527 19.0017 1.30699 18.2883C1.24999 17.5906 1.24999 16.7251 1.25 15.633V15.6V8.4V8.367C1.24999 7.27486 1.24999 6.40936 1.30699 5.71173C1.36527 4.99834 1.48688 4.39472 1.76772 3.84354C2.22312 2.94978 2.94978 2.22312 3.84354 1.76772C4.39472 1.48688 4.99834 1.36527 5.71173 1.30699C6.40936 1.24999 7.27486 1.24999 8.367 1.25ZM19 5.25C19.4142 5.25 19.75 5.58579 19.75 6V18C19.75 18.4142 19.4142 18.75 19 18.75C18.5858 18.75 18.25 18.4142 18.25 18V6C18.25 5.58579 18.5858 5.25 19 5.25ZM22 7.25C22.4142 7.25 22.75 7.58579 22.75 8V16C22.75 16.4142 22.4142 16.75 22 16.75C21.5858 16.75 21.25 16.4142 21.25 16V8C21.25 7.58579 21.5858 7.25 22 7.25ZM6 6.25C5.58579 6.25 5.25 6.58579 5.25 7C5.25 7.41421 5.58579 7.75 6 7.75H12C12.4142 7.75 12.75 7.41421 12.75 7C12.75 6.58579 12.4142 6.25 12 6.25H6ZM6 10.25C5.58579 10.25 5.25 10.5858 5.25 11C5.25 11.4142 5.58579 11.75 6 11.75H12C12.4142 11.75 12.75 11.4142 12.75 11C12.75 10.5858 12.4142 10.25 12 10.25H6ZM6 14.25C5.58579 14.25 5.25 14.5858 5.25 15C5.25 15.4142 5.58579 15.75 6 15.75H8C8.41421 15.75 8.75 15.4142 8.75 15C8.75 14.5858 8.41421 14.25 8 14.25H6Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 14V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H9.6C11.8402 22 12.9603 22 13.816 21.564C14.5686 21.1805 15.1805 20.5686 15.564 19.816C16 18.9603 16 17.8402 16 15.6V8.4C16 6.15979 16 5.03968 15.564 4.18404C15.1805 3.43139 14.5686 2.81947 13.816 2.43597C12.9603 2 11.8402 2 9.6 2H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V10M6 7H12M6 11H12M6 15H8M19 6V18M22 8V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 7H12M6 11H12M6 15H8M19 6V18M22 8V16M8.4 22H9.6C11.8402 22 12.9603 22 13.816 21.564C14.5686 21.1805 15.1805 20.5686 15.564 19.816C16 18.9603 16 17.8402 16 15.6V8.4C16 6.15979 16 5.03968 15.564 4.18404C15.1805 3.43139 14.5686 2.81947 13.816 2.43597C12.9603 2 11.8402 2 9.6 2H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M8.45 1.25C5.92976 1.25 4.66965 1.25 3.70704 1.74047C2.86031 2.1719 2.1719 2.86031 1.74047 3.70704C1.25 4.66965 1.25 5.92976 1.25 8.45V15.55C1.25 18.0702 1.25 19.3304 1.74047 20.293C2.1719 21.1397 2.86031 21.8281 3.70704 22.2595C4.66965 22.75 5.92976 22.75 8.45 22.75H9.55C12.0702 22.75 13.3304 22.75 14.293 22.2595C15.1397 21.8281 15.8281 21.1397 16.2595 20.293C16.75 19.3304 16.75 18.0702 16.75 15.55V8.45C16.75 5.92976 16.75 4.66965 16.2595 3.70704C15.8281 2.86031 15.1397 2.1719 14.293 1.74047C13.3304 1.25 12.0702 1.25 9.55 1.25H8.45Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19 5.25C19.4142 5.25 19.75 5.58579 19.75 6V18C19.75 18.4142 19.4142 18.75 19 18.75C18.5858 18.75 18.25 18.4142 18.25 18V6C18.25 5.58579 18.5858 5.25 19 5.25ZM5.25 7C5.25 6.58579 5.58579 6.25 6 6.25H12C12.4142 6.25 12.75 6.58579 12.75 7C12.75 7.41421 12.4142 7.75 12 7.75H6C5.58579 7.75 5.25 7.41421 5.25 7ZM22 7.25C22.4142 7.25 22.75 7.58579 22.75 8V16C22.75 16.4142 22.4142 16.75 22 16.75C21.5858 16.75 21.25 16.4142 21.25 16V8C21.25 7.58579 21.5858 7.25 22 7.25ZM5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11ZM5.25 15C5.25 14.5858 5.58579 14.25 6 14.25H8C8.41421 14.25 8.75 14.5858 8.75 15C8.75 15.4142 8.41421 15.75 8 15.75H6C5.58579 15.75 5.25 15.4142 5.25 15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
